module.exports = __webpack_public_path__ + "img/rmvb.d3b1bdbb.svg";